<template>
  <HeaderComponent />
  <div class="searchComponent">
    <div class="goBack">
      <img src="../assets/icons/arrowLeft.svg" />
      <p @click="goBack">Назад</p>
    </div>
    <div class="searchResult">
      <p class="searchResultText">Все анкеты {{ headCategory ? 'по категории "' + headCategory + '"' : "" }}</p>
      <div class="searchCategories">
        <div class="preferencesCategory" v-click-outside="closeDropDown" @click="openPreferences">
          <div class="categoryText">
            Предпочтения
            <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="categorySvg">
              <path d="M2.63398 5.5C3.01888 6.16667 3.98113 6.16667 4.36603 5.5L6.53109 1.75C6.91599 1.08333 6.43486 0.25 5.66506 0.25H1.33493C0.565135 0.25 0.084011 1.08333 0.468911 1.75L2.63398 5.5Z" fill="#333333" />
            </svg>
          </div>
          <Transition name="fade">
            <div class="categoryList" v-show="showPreferencesCategoryList">
              <div class="categoryBlockList" v-for="c in preferences" v-bind:key="c">
                <p style="font-weight: 600">{{ localizeCategory(c.category) }}</p>
                <ul @click="selectPreference">
                  <li v-for="cat in c.values" v-bind:key="cat" :id="cat._id" @click="changeCity">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="14" height="14" rx="3" fill="#F3F3F3" />
                    </svg>
                    {{ cat.name }}
                  </li>
                </ul>
              </div>
            </div>
          </Transition>
        </div>
        <div class="venueCategory" v-click-outside="closeDropDown" @click="openVenue">
          <div class="categoryText">
            Место встречи
            <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="venueSvg">
              <path d="M2.63398 5.5C3.01888 6.16667 3.98113 6.16667 4.36603 5.5L6.53109 1.75C6.91599 1.08333 6.43486 0.25 5.66506 0.25H1.33493C0.565135 0.25 0.084011 1.08333 0.468911 1.75L2.63398 5.5Z" fill="#333333" />
            </svg>
          </div>
          <Transition name="fade">
            <div class="categoryList" v-show="showVenueCategoryList">
              <div class="categoryBlockList">
                <p style="font-weight: 600">Место встречи</p>
                <ul @click="selectVenue">
                  <li v-for="v in venues" v-bind:key="v" @click="changeCity">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="14" height="14" rx="3" fill="#F3F3F3" />
                    </svg>
                    <p :id="v.type">{{ v.name }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </Transition>
        </div>
        <div class="optionsCategory" v-click-outside="closeDropDown" @click="openOptions">
          <div class="categoryText">
            Параметры
            <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="optionsSvg">
              <path d="M2.63398 5.5C3.01888 6.16667 3.98113 6.16667 4.36603 5.5L6.53109 1.75C6.91599 1.08333 6.43486 0.25 5.66506 0.25H1.33493C0.565135 0.25 0.084011 1.08333 0.468911 1.75L2.63398 5.5Z" fill="#333333" />
            </svg>
          </div>
          <Transition name="fade">
            <div class="categoryList" v-show="showOptionsCategoryList">
              <div class="categoryBlockList">
                <p style="font-weight: 600">Возраст, {{ age[0] }} - {{ age[1] }}</p>
                <VueSlider ref="slider" v-model="age" @dragEnd="repeatSearchClick" :min="18" :max="70" :minRange="1" :maxRange="age[1]" tooltip="hover" :processStyle="{ backgroundColor: '#FF8989' }" :tooltipStyle="{ backgroundColor: '#FF8989' }" silent />
                <p style="font-weight: 600">Рост, {{ height[0] }} - {{ height[1] }}</p>
                <VueSlider ref="slider" v-model="height" @dragEnd="repeatSearchClick" :min="120" :max="220" :minRange="1" :maxRange="height[1]" tooltip="hover" :processStyle="{ backgroundColor: '#FF8989' }" :tooltipStyle="{ backgroundColor: '#FF8989' }" silent />
                <p style="font-weight: 600">Вес, {{ weight[0] }} - {{ weight[1] }}</p>
                <VueSlider ref="slider" v-model="weight" @dragEnd="repeatSearchClick" :min="35" :max="120" :minRange="1" :maxRange="weight[1]" tooltip="hover" :processStyle="{ backgroundColor: '#FF8989' }" :tooltipStyle="{ backgroundColor: '#FF8989' }" silent />
              </div>
            </div>
          </Transition>
        </div>
        <div class="categoriesCategory" v-click-outside="closeDropDown" @click="openCategories">
          <div class="categoryText">
            Категории
            <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg" class="categoriesSvg">
              <path d="M2.63398 5.5C3.01888 6.16667 3.98113 6.16667 4.36603 5.5L6.53109 1.75C6.91599 1.08333 6.43486 0.25 5.66506 0.25H1.33493C0.565135 0.25 0.084011 1.08333 0.468911 1.75L2.63398 5.5Z" fill="#333333" />
            </svg>
          </div>
          <Transition name="fade">
            <div class="categoryList" v-show="showCategoriesCategoryList">
              <div class="categoryBlockList">
                <p style="font-weight: 600">Категории</p>
                <ul @click="selectCategory">
                  <li v-for="v in categories" v-bind:key="v" :id="v.type">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="14" height="14" rx="3" fill="#F3F3F3" />
                    </svg>
                    <p :id="v.type">{{ v.name }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </Transition>
        </div>
        <div class="">
          <p><br /></p>
        </div>
        <div class="otherCategory">
          <img src="../assets/icons/rotateLeft.svg" alt="Сбросить фильтры" style="cursor: pointer" @click="resetFilter" />
          <Transition name="fade">
            <button class="repeatSearch" v-if="isRepeatSearch" @click="repeatSearchClick">Повторить поиск</button>
          </Transition>
        </div>
      </div>
      <Transition name="fade">
        <div class="loading" v-show="isLoading">
          <LoadingAnimation />
        </div>
      </Transition>
      <TransitionGroup name="fade" v-if="!isLoading">
        <div class="resultBlock">
          <p v-if="isNotFound" class="searchResultText" style="font-size: 20px; margin-bottom: 5%">По Вашему запросу ничего не найдено!</p>
          <p class="searchResultText" style="font-size: 20px; margin-bottom: 2%" v-if="isNotFound">Похожие анкеты</p>
          <div class="listQuestionnaires" v-if="pagesCount > 0">
            <GirlCard
              v-for="girl in girlsOnPage"
              :key="girl._id"
              :girl="girl"
              :cityName="this.$store.getters.getCity"
              :linkHref="'/girl/' + girl._id"
              :buttonLinkHref="'/girl/' + girl._id"
            />
          </div>
        </div>

        <div class="pagesBlock">
          <div class="prevPage arrowBlock" @click="arrowClick">&lt;</div>
          <div class="pageBlock" v-if="girlsOnPage.length == 0">
            <p class="pageNumber">1</p>
          </div>
          <div class="pageBlock" v-else v-for="p in pages" v-bind:key="p" @click="changePage">
            <p class="pageNumber">{{ p }}</p>
          </div>
          <div class="nextPage arrowBlock" @click="arrowClick">&gt;</div>
        </div>
      </TransitionGroup>
    </div>
  </div>
  <FooterComponent />
</template>

<script>
import FooterComponent from "@/components/FooterComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import GirlCard from "@/components/GirlCard.vue";
// import categs from '@/data/categories'
import LoadingAnimation from "@/components/LoadingAnimation.vue";
import clickOutside from "@/directives/click-outside";
import axios from "axios";
import VueSlider from "vue-3-slider-component";
export default {
  name: "AllWhores",
  data() {
    return {
      girlsOnPage: [],
      query: this.$route.params.query,
      page: Number(this.$route.params.id),
      pages: [1, 2, 3, 4, 5],
      isLoading: false,
      showPreferencesCategoryList: false,
      showVenueCategoryList: false,
      showOptionsCategoryList: false,
      showCategoriesCategoryList: false,
      categories: [
        { name: "Премиум", type: "premium" },
        { name: "Элитные", type: "elite" },
        { name: "Индивидуалки", type: "individual" },
        { name: "Проститутки", type: "escort" },
        { name: "Массажистки", type: "massage" },
      ],
      venues: [
        { name: "У тебя", type: "YOU" },
        { name: "У меня", type: "ME" },
        { name: "У меня или у тебя", type: "YOUME" },
      ],
      selectedPreferences: [],
      selectedCategories: [],
      selectedVenue: "",
      isRepeatSearch: false,
      age: [18, 70],
      height: [120, 220],
      weight: [35, 120],
      headCategory: "",
      isNotFound: false,
      isGirlVerify: false,
    };
  },
  methods: {
    getPluralForm(number) {
      let forms = ["год", "года", "лет"];
      number = Math.abs(number) % 100;
      const lastDigit = number % 10;
      if (number > 10 && number < 20) return forms[2];
      if (lastDigit === 1) return forms[0];
      if (lastDigit >= 2 && lastDigit <= 4) return forms[1];
      return forms[2];
    },
    goBack() {
      window.location.href = "/";
    },
    openPreferences(event) {
      let el = event.target.closest(".preferencesCategory");
      let els = document.querySelector(".searchCategories");
      if (this.showVenueCategoryList || this.showOptionsCategoryList || this.showCategoriesCategoryList) {
        for (let i = 0; i < els.children.length - (this.isRepeatSearch ? 3 : 2); i++) {
          console.log("ДЕТИ", els.children[i]);
          els.children[i].querySelector("svg").style.transform = "rotate(90deg)";
        }
        this.showVenueCategoryList = false;
        this.showOptionsCategoryList = false;
        this.showCategoriesCategoryList = false;
        let svg = document.querySelector(".venueCategory .categoryText svg");
        svg.style.transform = "rotate(90deg)";
      }
      // if (event.target.closest('div').className != 'categoryList') this.showPreferencesCategoryList = true
      if (this.showPreferencesCategoryList && event.target.className == "categoryText") {
        for (let i = 0; i < els.children.length - (this.isRepeatSearch ? 3 : 2); i++) {
          els.children[i].querySelector("svg").style.transform = "rotate(90deg)";
        }
        this.showPreferencesCategoryList = false;
        console.log(123);
      } else {
        el.querySelector("svg").style.transform = "rotate(0deg)";
        this.showPreferencesCategoryList = true;
      }
    },
    resetFilter() {
      this.selectedPreferences = [];
      window.location.reload();
    },
    openVenue(event) {
      let el = event.target.closest(".venueCategory");
      let els = document.querySelector(".searchCategories");
      if (this.showPreferencesCategoryList || this.showOptionsCategoryList || this.showCategoriesCategoryList) {
        let els = document.querySelector(".searchCategories");
        for (let i = 0; i < els.children.length - (this.isRepeatSearch ? 3 : 2); i++) {
          els.children[i].querySelector("svg").style.transform = "rotate(90deg)";
        }
        this.showPreferencesCategoryList = false;
        this.showOptionsCategoryList = false;
        this.showCategoriesCategoryList = false;
        let svg = document.querySelector(".preferencesCategory .categoryText svg");
        svg.style.transform = "rotate(90deg)";
      }
      if (this.showVenueCategoryList && event.target.className == "categoryText") {
        for (let i = 0; i < els.children.length - (this.isRepeatSearch ? 3 : 2); i++) {
          els.children[i].querySelector("svg").style.transform = "rotate(90deg)";
        }
        this.showVenueCategoryList = false;
      } else {
        el.querySelector("svg").style.transform = "rotate(0deg)";
        this.showVenueCategoryList = true;
      }
    },
    openOptions(event) {
      let el = event.target.closest(".optionsCategory");
      let els = document.querySelector(".searchCategories");
      if (this.showPreferencesCategoryList || this.showVenueCategoryList || this.showCategoriesCategoryList) {
        let els = document.querySelector(".searchCategories");
        for (let i = 0; i < els.children.length - (this.isRepeatSearch ? 3 : 2); i++) {
          els.children[i].querySelector("svg").style.transform = "rotate(90deg)";
        }
        this.showPreferencesCategoryList = false;
        this.showVenueCategoryList = false;
        this.showCategoriesCategoryList = false;
        let svg = document.querySelector(".optionsCategory .categoryText svg");
        svg.style.transform = "rotate(90deg)";
      }
      if (this.showOptionsCategoryList && event.target.className == "categoryText") {
        for (let i = 0; i < els.children.length - (this.isRepeatSearch ? 3 : 2); i++) {
          els.children[i].querySelector("svg").style.transform = "rotate(90deg)";
        }
        this.showOptionsCategoryList = false;
      } else {
        el.querySelector("svg").style.transform = "rotate(0deg)";
        this.showOptionsCategoryList = true;
      }
    },
    openCategories(event) {
      let el = event.target.closest(".categoriesCategory");
      let els = document.querySelector(".searchCategories");
      if (this.showPreferencesCategoryList || this.showVenueCategoryList || this.showOptionsCategoryList) {
        let els = document.querySelector(".searchCategories");
        for (let i = 0; i < els.children.length - (this.isRepeatSearch ? 3 : 2); i++) {
          els.children[i].querySelector("svg").style.transform = "rotate(90deg)";
        }
        this.showPreferencesCategoryList = false;
        this.showVenueCategoryList = false;
        this.showOptionsCategoryList = false;
        let svg = document.querySelector(".categoriesCategory .categoryText svg");
        svg.style.transform = "rotate(0deg)";
      }
      if (this.showCategoriesCategoryList && event.target.className == "categoryText") {
        for (let i = 0; i < els.children.length - (this.isRepeatSearch ? 3 : 2); i++) {
          els.children[i].querySelector("svg").style.transform = "rotate(90deg)";
        }
        this.showCategoriesCategoryList = false;
      } else {
        el.querySelector("svg").style.transform = "rotate(0deg)";
        this.showCategoriesCategoryList = true;
      }
    },
    changePage(event) {
      let el = event.target.closest("div");
      this.page = Number(el.children[0].innerText);
      let route = this.$route.fullPath.split("/");
      if (route.length == 4) {
        this.$router.push(`/${route[1]}/${route[2]}/${this.page}`);
      } else {
        this.$router.push(`/girls/${this.page}`);
        this.$route.params.page = 2;
      }
      this.searchGirls();
    },
    arrowClick(event) {
      if (this.pagesCount != 0) {
        let e = event.target.closest("div");
        let route = this.$route.fullPath.split("/");
        if (e.classList[0] == "prevPage") {
          if (this.page != 1) {
            this.page -= 1;
            if (route.length == 4) {
              this.$router.push(`/${route[1]}/${route[2]}/${this.page}`);
            } else {
              this.$router.push(`/girls/${this.page}`);
              this.$route.params.page = 2;
            }
            this.searchGirls();
          }
        } else {
          if (this.page != this.pagesCount) {
            this.page += 1;
            if (route.length == 4) {
              this.$router.push(`/${route[1]}/${route[2]}/${this.page}`);
            } else {
              this.$router.push(`/girls/${this.page}`);
              this.$route.params.page = 2;
            }
            this.searchGirls();
          }
        }
      }
    },
    closeDropDown(event) {
      if (!event.target.closest(".categoryText") && !event.target.closest(".categorylist") && !event.target.closest(".categoryBlockList") && !event.target.closest(".mainMenu")) {
        if (this.showVenueCategoryList) {
          this.showVenueCategoryList = false;
          let svg = document.querySelector(".venueCategory .categoryText svg");
          svg.style.transform = "rotate(90deg)";
        }
        if (this.showPreferencesCategoryList) {
          this.showPreferencesCategoryList = false;
          console.log("ААААААААА", event.target);
          let svg = document.querySelector(".preferencesCategory .categoryText svg");
          console.log(svg);
          svg.style.transform = "rotate(90deg)";
        }
        if (this.showOptionsCategoryList) {
          this.showOptionsCategoryList = false;
          let svg = document.querySelector(".optionsCategory .categoryText svg");
          console.log(svg);
          svg.style.transform = "rotate(90deg)";
        }
        if (this.showCategoriesCategoryList) {
          this.showCategoriesCategoryList = false;
          let svg = document.querySelector(".categoriesCategory .categoryText svg");
          console.log(svg);
          svg.style.transform = "rotate(90deg)";
        }
      }
    },
    selectPreference(event) {
      let el = event.target.closest("li");
      console.log(el);
      if (el != null) {
        console.log(el.innerText);
        let svg = el.querySelector("svg rect");
        if (svg.style.fill == "rgb(255, 137, 137)") {
          let ind = this.selectedPreferences.indexOf(el.id);
          this.selectedPreferences.splice(ind, 1);
          svg.style.fill = "#f3f3f3";
        } else {
          this.selectedPreferences.push(el.id);
          svg.style.fill = "#ff8989";
        }
      }
      if (this.selectedPreferences.length > 0) this.isRepeatSearch = true;
      else this.isRepeatSearch = false;
    },
    selectVenue(event) {
      let el = event.target.closest("li");
      let venues = document.querySelector(".venueCategory");
      venues = venues.querySelectorAll(".categoryBlockList ul li svg rect");
      for (let v of venues) v.style.fill = "#F3F3F3";
      el.querySelector("svg rect").style.fill = "#ff8989";
      if (el != null) {
        if (el.innerText == "У тебя") this.selectedVenue = "YOU";
        else if (el.innerText == "У меня") this.selectedVenue = "ME";
        else this.selectedVenue = "YOUME";
      }

      if (this.selectedVenue.length > 0) this.isRepeatSearch = true;
      else this.isRepeatSearch = false;
    },
    selectCategory(event) {
      let el = event.target.closest("li");
      if (el != null) {
        console.log(el.innerText);
        let svg = el.querySelector("svg rect");
        if (svg.style.fill == "rgb(255, 137, 137)") {
          let ind = this.selectedCategories.indexOf(el.id);
          this.selectedCategories.splice(ind, 1);
          svg.style.fill = "#f3f3f3";
        } else {
          this.selectedCategories.push(el.id);
          svg.style.fill = "#ff8989";
        }
      }
      console.log(this.selectedCategories);
      if (this.selectedCategories.length > 0) this.isRepeatSearch = true;
      else this.isRepeatSearch = false;
    },
    repeatSearchClick() {
      this.page = 1;
      this.$router.push(`/girls/${this.page}`);
      this.searchGirls();
    },
    searchGirls() {
      this.isLoading = true;
      console.log("КВЕРИ", this.$route);
      axios
        .get(`https://${process.env.VUE_APP_SERVERHOST}/api/girl/new-search`, {
          params: {
            q: "",
            place: this.selectedVenue.length > 0 ? this.selectedVenue : null,
            preferences: this.selectedPreferences.toString(),
            ageFrom: this.age[0],
            ageTo: this.age[1],
            heightFrom: this.height[0],
            heightTo: this.height[1],
            weightFrom: this.weight[0],
            weightTo: this.weight[1],
            ...(this.selectedCategories.includes("escort") ? { escort: true } : {}),
            ...(this.selectedCategories.includes("slut") ? { slut: true } : {}),
            ...(this.selectedCategories.includes("individual") ? { individual: true } : {}),
            ...(this.selectedCategories.includes("premium") ? { premium: true } : {}),
            ...(this.selectedCategories.includes("elite") ? { elite: true } : {}),
            ...(this.selectedCategories.includes("massage") ? { massage: true } : {}),
            page: this.page,
            limit: 12,
          },
          headers: {
            Authorization: "Bearer " + this.$store.state.userData.token,
          },
        })
        .then(async (res) => {
          console.log(res);
          if (res.data.result.total == 0) {
            console.log("ПОВТОРНЫЙ ЗАПРОС");
            this.isNotFound = true;
            axios
              .get(`https://${process.env.VUE_APP_SERVERHOST}/api/girl/new-search`, {
                params: {
                  q: "",
                  page: this.page,
                  limit: 6,
                },
                headers: {
                  Authorization: "Bearer " + this.$store.state.userData.token,
                },
              })
              .then(async (res) => {
                console.log(res);
                this.pagesCount = Math.ceil(res.data.result.total / 12);
                this.girlsOnPage = res.data.result.data;
                if (this.pagesCount < 5) {
                  if (this.pagesCount == 1) this.pages = [1];
                  else if (this.pagesCount == 2) this.pages = [1, 2];
                  else if (this.pagesCount == 3) this.pages = [1, 2, 3];
                  else if (this.pagesCount == 4) this.pages = [1, 2, 3, 4];
                } else {
                  if (this.page > 3) this.pages = [this.page - 2, this.page - 1, this.page, this.page + 1, this.page + 2];
                  if (this.page == this.pagesCount - 1) this.pages = [this.page - 3, this.page - 2, this.page - 1, this.page, this.page + 1];
                  else if (this.page == this.pagesCount) this.pages = [this.page - 4, this.page - 3, this.page - 2, this.page - 1, this.page];
                }
                this.isLoading = false;
                await this.$nextTick();
                let pages = document.querySelectorAll(".pageNumber");
                for (let p of pages)
                  if (p.innerText == this.page) {
                    p.parentNode.classList.add("pageBlockSelected");
                    p.classList.add("pageNumberSelected");
                  }
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            this.isNotFound = false;
            this.pagesCount = Math.ceil(res.data.result.total / 12);
            this.girlsOnPage = res.data.result.data;
            if (this.pagesCount < 5) {
              if (this.pagesCount == 1) this.pages = [1];
              else if (this.pagesCount == 2) this.pages = [1, 2];
              else if (this.pagesCount == 3) this.pages = [1, 2, 3];
              else if (this.pagesCount == 4) this.pages = [1, 2, 3, 4];
            } else {
              if (this.page > 3) this.pages = [this.page - 2, this.page - 1, this.page, this.page + 1, this.page + 2];
              if (this.page == this.pagesCount - 1) this.pages = [this.page - 3, this.page - 2, this.page - 1, this.page, this.page + 1];
              else if (this.page == this.pagesCount) this.pages = [this.page - 4, this.page - 3, this.page - 2, this.page - 1, this.page];
            }
            this.isLoading = false;
            await this.$nextTick();
            let pages = document.querySelectorAll(".pageNumber");
            for (let p of pages)
              if (p.innerText == this.page) {
                p.parentNode.classList.add("pageBlockSelected");
                p.classList.add("pageNumberSelected");
              }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadCategories() {
      axios
        .get(`https://${process.env.VUE_APP_SERVERHOST}/api/public/preferences`, {
          headers: {
            Authorization: "Bearer " + this.$store.state.userData.token,
          },
        })
        .then((res) => {
          const groupedByCategory = res.data.result.reduce((acc, item) => {
            const { category, name, _id } = item;
            if (!acc[category]) {
              acc[category] = { category, values: [] };
            }
            acc[category].values.push({ name, _id });
            return acc;
          }, {});
          this.preferences = groupedByCategory;
        });
    },
    localizeCategory(category) {
      const loc = [
        { name: "SEX", local: "Секс" },
        { name: "MASSAGE", local: "Массаж" },
        { name: "EXTREME", local: "Экстрим" },
        { name: "BDSM", local: "Садо-Мазо" },
        { name: "STRIPTEASE", local: "Стриптиз" },
        { name: "ETC", local: "Разное" },
      ];
      const isNamePresent = loc.find((item) => item.name === category);
      return isNamePresent.local;
    },
  },
  mounted() {
    this.loadCategories();
    if (this.$route.params.query.length > 0) this.selectedPreferences.push(this.$route.params.query);
    if (this.$route.query.premium) {
      this.selectedCategories.push("premium");
      this.headCategory = "Премиум";
    }
    if (this.$route.query.escort) {
      this.selectedCategories.push("escort");
      this.headCategory = "Эскортницы";
    }
    if (this.$route.query.slut) {
      this.selectedCategories.push("slut");
      this.headCategory = "Проститутки";
    }
    if (this.$route.query.individual) {
      this.selectedCategories.push("individual");
      this.headCategory = "Индивидуалки";
    }
    if (this.$route.query.elite) {
      this.selectedCategories.push("elite");
      this.headCategory = "Элитные";
    }
    if (this.$route.query.massage) {
      this.selectedCategories.push("massage");
      this.headCategory = "Массажистки";
    }
    this.searchGirls();
  },
  components: {
    HeaderComponent,
    FooterComponent,
    GirlCard,
    LoadingAnimation,
    VueSlider,
  },
  directives: {
    clickOutside,
  },
};
</script>
<style scoped>
.searchComponent {
  width: 64vw;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.goBack {
  display: flex;
  gap: 5px;
  margin-top: 3%;
  margin-bottom: 2%;
  cursor: pointer;
  width: fit-content;
}
.goBack p {
  font-weight: 600;
}
.searchResultText {
  font-size: 32px;
  font-weight: 600;
}
.pagesBlock {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 5%;
}
.pageBlock {
  padding: 30px;
  width: 50px;
  height: 50px;
  border: 1px solid #ff8989;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.searchCategories div {
  user-select: none;
}
.pageNumber {
  font-size: 18px;
  font-weight: 700;
  color: #ff8989;
}
.pageBlockSelected {
  background-color: #ff8989;
}
.pageNumberSelected {
  color: white;
}
.arrowBlock {
  padding: 30px;
  width: 50px;
  height: 50px;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 700;
  color: #bcbcbc;
  cursor: pointer;
  transition: 0.4s;
}
.arrowBlock:hover {
  color: #ff8989;
  border: 1px solid #ff8989;
  transition: 0.4s;
}
ul {
  list-style-type: none;
  padding-left: 0;
}
ul li {
  user-select: none;
}
.categorySvg,
.venueSvg,
.optionsSvg,
.categoriesSvg {
  transform: rotate(90deg);
  transition: 0.2s ease-in-out;
}
.listQuestionnaires {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}
.questionnaire {
  background-color: #fbfbfb;
  border: 1px solid #f4f4f4;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
}
.mainInfoQuestionnaire {
  display: flex;
  height: 80%;
  gap: 20px;
}
.girlPhoto {
  width: 60%;
}
.girlPhoto img {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  object-fit: cover;
}
.infoGirl {
  width: 70%;
}
.girlName {
  font-size: 16px;
  font-weight: 600;
  display: flex;
  gap: 5px;
  align-items: center;
  position: relative;
}

.verifyPopUp {
  position: absolute;
  bottom: 125%; /* выше иконки */
  left: 50%;
  transform: translateX(-50%);
  background-color: #2f2f2f;
  color: #fff;
  padding: 6px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  z-index: 10;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.verifyPopUp p {
  display: flex;
  align-items: center;
  margin-bottom: 0 !important;
  font-size: 14px;
  font-weight: 500;
}

.verify-wrapper:hover .verifyPopUp {
  opacity: 1;
}
.infoGirl p:nth-child(2) {
  font-size: 14px;
  margin-bottom: 10px;
}
.priceGirl {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.featuresGirl {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.pinkFeature {
  background-color: #ff898926;
  color: #ff8989;
  font-size: 15px;
  font-weight: 600;
  border-radius: 10px;
  display: flex;
  padding: 5px 7px 5px 7px;
}
.blueFeature {
  background-color: #89bfff26;
  color: #89bfff;
  font-size: 15px;
  font-weight: 600;
  border-radius: 10px;
  padding: 5px 7px 5px 7px;
}
.hourRent {
  display: flex;
  gap: 20px;
}
.infoHour {
  display: flex;
  flex-direction: column;
  color: #2f2f2f;
}
.infoHour span {
  font-family: "Noto Sans";
  display: flex;
  align-items: center;
}
.priceSum {
  display: flex;
}
.headInfoHour {
  display: flex;
  align-items: center;
  gap: 7px;
  font-weight: 600;
  color: #ff8989;
}
.headInfoHour p {
  text-align: center;
}
.infoHour:nth-child(3) .headInfoHour {
  color: #2f2f2f;
}
.reservationButton {
  background-color: #2f2f2f;
  border-radius: 10px;
  border: 1px solid #2f2f2f;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  font-weight: 600;
  color: #ffffff;
  padding: 10px;
  cursor: pointer;
}
.allQuestionnaires {
  width: 100%;
  background-color: #ff8989;
  color: #ffffff;
  font-weight: 600;
  border-radius: 10px;
  border: 1px solid #ff8989;
  padding: 10px;
  margin-bottom: 7%;
  cursor: pointer;
}
.otherCategory {
  display: flex;
  gap: 10px;
  align-items: center;
}
.searchResult {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.searchCategories {
  display: flex;
  gap: 20px;
}
.preferencesCategory,
.venueCategory,
.optionsCategory,
.categoriesCategory {
  background-color: #fbfbfb;
  border: 1px solid #f4f4f4;
  border-radius: 30px;
  padding: 5px 23px 5px 23px;
  display: flex;
  align-items: center;
  gap: 7px;
  font-size: 18px;
  position: relative;
}
.categoryText {
  cursor: pointer;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
}
.resultBlock {
  margin-bottom: 5%;
}
.categoryList {
  max-height: 30vh;
  width: 200%;
  position: absolute;
  top: 150%;
  left: 0;
  background-color: #fbfbfb;
  border: 1px solid #f4f4f4;
  border-radius: 10px;
  overflow-y: auto;
  padding: 15%;
  z-index: 5;
}
.venueCategory .categoryList {
  width: 150%;
}
.categoryBlockList {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.categoryBlockList ul li {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
}
.repeatSearch {
  width: fit-content;
  background-color: #2f2f2f;
  border: 1px solid transparent;
  border-radius: 55px;
  color: white;
  padding: 5px 23px 5px 23px;
  cursor: pointer;
}
:deep(.vue-slider-dot-tooltip-inner) {
  border-color: #ff8989;
}
@media (max-width: 968px) {
  .listQuestionnaires {
    grid-template-columns: 1fr;
  }
  .pageBlock {
    padding: 15px;
  }
  .arrowBlock {
    padding: 15px;
  }
  .searchComponent {
    width: 90%;
    overflow-x: hidden;
  }
  .searchCategories {
    display: grid;
    grid-template-columns: 1fr 1fr;
    position: relative;
  }
  .categoryText {
    font-size: 14px;
  }
  .categoryList {
    max-height: 100vh;
  }
  .venueCategory .categoryList,
  .categoriesCategory .categoryList {
    right: 20px;
    left: unset;
    width: 150%;
  }
  .preferencesCategory,
  .venueCategory,
  .optionsCategory,
  .categoriesCategory {
    justify-content: center;
  }
  .repeatSearch {
    padding: 5px 10px 5px 10px;
    font-size: 14px;
    justify-self: right;
  }
  .otherCategory {
    justify-self: right;
    position: absolute;
    bottom: 0;
  }
  .pagesBlock {
    gap: 10px;
  }
}
@media (max-width: 1200px) {
  .headInfoHour p {
    font-size: 14px;
  }
}
@media (max-width: 1800px) {
  .searchComponent {
    width: 90vw;
  }
}
</style>
